module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3pNIgn3UaHHftGoDMuf8Ak-437022cccbc266c34b77040f03c1aae7.jpg";